import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Utilizar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-20" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Produto")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Unidade")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Quantidade")
  ])
], -1)
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "ant-col ant-col-xs-16 ant-col-xl-2" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "ant-col ant-col-xs-5 ant-col-xl-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_kit_produtos = _resolveComponent("selecionar-kit-produtos")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_card = _resolveComponent("card")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: 'Utilizar Kit',
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "1000px",
    centered: "",
    "wrap-class-name": "ss-modal-cadastros"
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.utilizar && _ctx.utilizar(...args)))
        }, _hoisted_2)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_form_item, {
                label: "Kit de Produtos",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_selecionar_kit_produtos, {
                    empresas: [_ctx.props.empresa],
                    codigoSelecionado: _ctx.state.kitSelecionado,
                    "onUpdate:codigoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.kitSelecionado) = $event)),
                    onChange: _ctx.obterItens
                  }, null, 8, ["empresas", "codigoSelecionado", "onChange"])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_card, { titulo: "Itens" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_spin, {
                spinning: _ctx.state.carregando,
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  (!_ctx.UtilitarioGeral.validaLista(_ctx.state.itens))
                    ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                        key: 0,
                        mensagem: "Nenhuma kit informado ainda"
                      }))
                    : (_openBlock(), _createBlock(_component_a_form, {
                        key: 1,
                        name: "ss-form-produto-fornecedores",
                        class: "ss-altura-rolagem-padrao ss-desabilitar-rolagem-horizontal"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.itens, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "ant-row ss-grade-personalizada-linha",
                              key: index
                            }, [
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("input", {
                                  class: "ant-input",
                                  type: "text",
                                  value: item.descricaoProduto,
                                  disabled: ""
                                }, null, 8, _hoisted_7)
                              ]),
                              _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("input", {
                                  class: "ant-input",
                                  type: "text",
                                  value: item.descricaoUnidade,
                                  disabled: ""
                                }, null, 8, _hoisted_9)
                              ]),
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_campo_numerico, {
                                  "quantidade-casas-decimais": item.casasDecimais,
                                  valor: item.quantidade,
                                  disabled: true
                                }, null, 8, ["quantidade-casas-decimais", "valor"])
                              ])
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["spinning"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}